


































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import _ from "lodash";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class AccountHolderWidgetBase extends Vue {
  @Prop ()
  title: string;

  @Prop ({ required: false, default: false})
  isLoading: boolean;

  @Prop ({ required: true, default: false })
  noRecordsFound: boolean;

  @Prop ({ required: false, default: false })
  isFailed: boolean;

  @Prop ({ required: false, default: true })
  collapsedOnStart: boolean;

  @Prop({ required: false })
  onExpanded: () => void;

  visible = false;
  onExpandedOnce: () => void;

  mounted () {
    this.visible = !this.collapsedOnStart;
    if (this.collapsedOnStart) {
      this.visible = false;
    }

    if (this.onExpanded) {
      this.onExpandedOnce = _.once(this.onExpanded);
    }
  }

  get key () {
    return this.title.replace(" ", "-");
  }

  @Watch("visible")
  onVisibleChange () {
    if (this.visible && this.onExpandedOnce) {
      this.onExpandedOnce();
    }
  }
}
